import { wsService } from "./wsService";

//Politicas de reposicion: calculan min/max y ubicaciones de las reglas de reposicion por categoria.
//La simulacion / aplicacion y el log viven en reposicionRuleService (prefijo rules/reposicion).
const section = "rules/politicas-reposicion";

function filter(param = { enable: true }) {
  return wsService.make_post_request(section + "/list", param);
}

function get(param = {}) {
  return wsService.make_post_request(section + "/get", param);
}

function create(param = {}) {
  return wsService.make_post_request(section + "/create", param);
}

function update(param = {}) {
  return wsService.make_put_request(section + "/update", param);
}

function remove(param = {}) {
  return wsService.make_delete_request(section + "/delete", param);
}

//Importacion por Excel: una politica por fila, si ya existe (almacen + cliente + categoria +
//subcategoria) se actualiza
function get_excel_headers_version(param = {}) {
  return wsService.make_post_request(section + "/get-excel-headers-version", param);
}

function import_line_excel(param = {}) {
  return wsService.make_post_request(section + "/import-line", param);
}

export const politicaReposicionService = {
  section,
  filter,
  get,
  remove,
  create,
  update,
  get_excel_headers_version,
  import_line_excel,
};
